import { atom, useAtomValue, useSetAtom } from 'jotai';

/**
 * The UUID (ltGrpId) of the newly created listing group to scroll to.
 * Null means no pending scroll.
 */
export const newGroupIdAtom = atom<string | null>(null);

/**
 * When set, after the new group appears in the catalog data the group modal
 * should be re-opened directly on the AutoPricing tab so the user can
 * configure autopricing without an extra click.
 */
export const openAutoPricingForGroupIdAtom = atom<string | null>(null);

// Convenience hooks matching the previous API
export const useNewGroupId = () => useAtomValue(newGroupIdAtom);
export const useSetNewGroupId = () => useSetAtom(newGroupIdAtom);
export const useOpenAutoPricingForGroupId = () =>
  useAtomValue(openAutoPricingForGroupIdAtom);
export const useSetOpenAutoPricingForGroupId = () =>
  useSetAtom(openAutoPricingForGroupIdAtom);
